import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import TableComponent from "./AssetDetailsTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import axios from "axios";
import { clientAccess } from "../../utils/index";
import "bootstrap/dist/css/bootstrap.css";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";

import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Accordion } from "react-bootstrap";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class AssetDetail extends React.Component {
  state = {
    LandlordGroups: [],
    clientList: [],
    showPopupAsset: false,
    showPopupTower: false,
    showPopupToc: false,
    redirect: false,
    assetTypes: [],
    assets: [],
    subAssets: [],
    countries: [],
    states: [],
    districts: [],
    popupContent: "",
    messsagePopup: false,
    delete: false,
    cities: [],
    assetType: "",
    asset: "",
    subAsset: "",
    cityId: "",
    url: `${apiUrl.apiUrl.url}/asset/create-tower`,
    id: undefined,
    assetImage: null,
    towerImage: null,
    tocImage: null,
    logoImage: null,
    cropperRef: React.createRef(),
    cropperTowerRef: React.createRef(),
    cropperTocRef: React.createRef(),
    cropperLogoRef: React.createRef(),
    initialValues: {
      groupId: "",
      groupName: "",
      clientId: "",
      clientName: "",
      assetTypeId: "",
      region: "",
      assetId: "",
      subAssetId: "",
      towerName: "",
      latiTude: "",
      longiTude: "",
      pinCode: "",
      assetName: "",
      subAssetName: "",
      assetType: "",
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      compliance_count: "",
      compliance_percent: "",
      assetCompliance: [],
      ownershipType: "",
      officeArea: "",
      structure: "",
      retailsArea: "",
      floorPlateRange: "",
      assetImage: "",
      towerImage: "",
      assetDesc: "",
      logoImage: null,
      tocImage: null,
      remCode: "",
    },
  };

  constructor(props) {
    super(props);
    // this.state = {
    //   image: null,
    // };
    //this.cropperRef = React.createRef();
  }

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/unit-detail/get-asset-types`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Handle the image file change
  onImageChange = (e, type) => {
    e.preventDefault();
    const files = e.target.files;
    if (files && files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => {
        if (type == "asset") {
          this.setState({ assetImage: reader.result, showPopupAsset: true });
        } else if (type == "tower") {
          this.setState({ towerImage: reader.result, showPopupTower: true });
        } else if (type == "tocImage") {
          this.setState({ tocImage: reader.result, showPopupToc: true });
        } else {
          this.setState({ logoImage: reader.result, showPopupLogo: true });
        }
      };
      reader.readAsDataURL(files[0]);
    }
  };

  removeImage = (type) => {
    if (type == "asset") {
      this.setState({ assetImage: '' })
    } else if (type == "tower") {
      this.setState({ towerImage: '' })
    } else if (type == "tocImage") {
      this.setState({ tocImage: '' })
    } else {
      this.setState({ logoImage: '' })
    }
  }

  // Handle cropping the image
  getCroppedImage = (e, type) => {
    e.preventDefault();
    let cropper, croppedCanvas, croppedImageUrl;
    if (type == "asset") {
      cropper = this.state.cropperRef.current.cropper;
    } else if (type == "tower") {
      cropper = this.state.cropperTowerRef.current.cropper;
    } else if (type == "tocImage") {
      cropper = this.state.cropperTocRef.current.cropper;
    } else {
      cropper = this.state.cropperLogoRef.current.cropper;
    }


    croppedCanvas = cropper.getCroppedCanvas();
    if (croppedCanvas) {
      croppedImageUrl = croppedCanvas.toDataURL();
      console.log("Cropped Image URL:", croppedImageUrl);

      if (type == "asset") {
        this.setState({ assetImage: croppedImageUrl });
      } else if (type == "tower") {
        this.setState({ towerImage: croppedImageUrl });
      } else if (type == "tocImage") {
        this.setState({ tocImage: croppedImageUrl });
      } else {
        this.setState({ logoImage: croppedImageUrl });
      }
      // You can process or upload the cropped image here
    }
  };

  complianceList = (clientId, id) => {
    var ths = this;
    fetch(
      `${apiUrl.apiUrl.url}/compliance/get-list-asset?client_id=${clientId}&id=${id}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "compliance data");
        // this.setState({
        //   assetCompliance: data.data,
        // });
        ths.state.initialValues.assetCompliance = data.data;
        ths.state.compliance_count = data.count;
        ths.state.compliance_percent = data.percent_count;
        ths.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeCountry = (e) => {
    let countryid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/site/country-states/?country_id=` + countryid, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeState = (e) => {
    let stateId = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/site/state-districts?state_id=` + stateId, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          districts: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeDistrict = (e) => {
    let districtId = e.target.value;
    console.log(districtId, "SI");
    fetch(
      `${apiUrl.apiUrl.url}/site/district-cities?district_id=` + districtId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          cities: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCityId(e) {
    this.state.cityId = e.target.value;
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/asset/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this item",
        });
      } else {
        self.setState({
          delete: true,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/asset/create-tower`,

          initialValues: {
            groupId: "",
            groupName: "",
            clientId: "",
            clientName: "",
            assetTypeId: "",
            region: "",
            assetId: "",
            subAssetId: "",
            towerName: "",
            assetName: "",
            subAssetName: "",
            assetType: "",
            latiTude: "",
            longiTude: "",
            pinCode: "",
            assetCompliance: [],
            ownershipType: "",
            isCoWorking: "",
            efficiencyOnUsableArea: "",
            totalSeatUsable: "",
            efficiencyOnBillableArea: "",
            totalSeatBillable: "",
            officeArea: "",
            structure: "",
            retailsArea: "",
            floorPlateRange: "",
            assetImage: "",
            towerImage: "",
            assetDesc: "",
            logoImage: null,
            tocImage: null,
            remCode:""
          },
        });
      } else {

        let athis = this;
        axios({
          method: "get",
          url: `${apiUrl.apiUrl.url}/asset/fetch-tower?id=${this.props.match.params.id}`
        }).then(function (response) {
          let data = response.data;
          data.data["assetDesc"] = data.assets[0]["desc"] || "";

          athis.setState({
            url: `${apiUrl.apiUrl.url}/asset/update-tower?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            subAssets: data.subAssets,
            assets: data.assets,
            countries: data.countries,
            states: data.state,
            districts: data.district,
            cities: data.cities,
            LandlordGroups: data.LandlordGroups,
            clientList: data.clientList,
            assetCompliance: [],
          });

          if (data.assetImage.length > 0) {
            athis.setState({ assetImage: `${apiUrl.apiUrl.url}/${data.assetImage}` });
          } else {
            athis.setState({ assetImage: null });
          }
          if (data.towerImage.length > 0) {
            athis.setState({ towerImage: `${apiUrl.apiUrl.url}/${data.towerImage}` });
          } else {
            athis.setState({ towerImage: null });
          }


          if (data.tocImage.length > 0) {
            athis.setState({ tocImage: `${apiUrl.apiUrl.url}/${data.tocImage}` });
          } else {
            athis.setState({ tocImage: null });
          }

          if (data.logoImage.length > 0) {
            athis.setState({ logoImage: `${apiUrl.apiUrl.url}/${data.logoImage}` });
          } else {
            athis.setState({ logoImage: null });
          }

          //athis.state.initialValues.assetDesc = data.assets.desc;
          athis.complianceList(data.data.clientId, data.data.assetId);
          // console.log("heelo");
          //console.log(data.assets[0]["desc"], "data.assets.desc");
          //console.log(data.data);
        });

        // fetch(
        //   `${apiUrl.apiUrl.url}/asset/fetch-tower?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     data.data["assetDesc"] = data.assets[0]["desc"] || "";

        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/asset/update-tower?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       subAssets: data.subAssets,
        //       assets: data.assets,
        //       countries: data.countries,
        //       states: data.state,
        //       districts: data.district,
        //       cities: data.cities,
        //       LandlordGroups: data.LandlordGroups,
        //       clientList: data.clientList,
        //       assetCompliance: [],
        //     });

        //     if (data.assetImage.length > 0) {
        //       this.setState({ assetImage: `${apiUrl.apiUrl.url}/${data.assetImage}` });
        //     } else {
        //       this.setState({ assetImage: null });
        //     }
        //     if (data.towerImage.length > 0) {
        //       this.setState({ towerImage: `${apiUrl.apiUrl.url}/${data.towerImage}` });
        //     } else {
        //       this.setState({ towerImage: null });
        //     }


        //     if (data.tocImage.length > 0) {
        //       this.setState({ tocImage: `${apiUrl.apiUrl.url}/${data.tocImage}` });
        //     } else {
        //       this.setState({ tocImage: null });
        //     }

        //     if (data.logoImage.length > 0) {
        //       this.setState({ logoImage: `${apiUrl.apiUrl.url}/${data.logoImage}` });
        //     } else {
        //       this.setState({ logoImage: null });
        //     }

        //     //this.state.initialValues.assetDesc = data.assets.desc;
        //     this.complianceList(data.data.clientId, data.data.assetId);
        //     // console.log("heelo");
        //     console.log(data.assets[0]["desc"], "data.assets.desc");
        //     console.log(data.data);
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }

  handleChangeAssetType = (newValue, actionMeta) => {
    console.log(newValue, "nw");
    this.state.initialValues.assetType = newValue.label;
    this.state.initialValues.assetTypeId = newValue.value;
    this.setState({});
    console.group("Value Changed");
    this.assetType = newValue.value;
    if (!isNaN(this.assetType)) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-assets-by-filter?asset_type_id=${this.assetType}&city_id=${this.state.cityId}`,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            assets: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.state.initialValues.assetDesc = '';
      this.setState({ assetImage: null });
      this.setState({});
    }




    console.groupEnd();
  };

  handleChangeAsset = (newValue, actionMeta) => {
    this.state.initialValues.assetName = newValue.label;
    this.state.initialValues.assetId = newValue.value;
    this.setState({});
    console.group("Value Changed");
    this.asset = newValue.value;
    if (!isNaN(this.asset)) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-sub-assets?asset_id=` +
        this.asset,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            subAssets: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });


      console.log(this.state.assets, "asset list", this.state.initialValues.assetId)

      var selectedAsset = this.state.assets.filter(item => item.id == newValue.value);

      if (selectedAsset.length > 0) {
        if (selectedAsset[0].image.length > 0) {
          this.setState({ assetImage: `${apiUrl.apiUrl.url}/${selectedAsset[0].image}` });
        } else {
          this.setState({ assetImage: null });
        }
        if (selectedAsset[0].toc_image.length > 0) {
          this.setState({ tocImage: `${apiUrl.apiUrl.url}/${selectedAsset[0].toc_image}` });
        } else {
          this.setState({ tocImage: null });
        }
        if (selectedAsset[0].logo_image.length > 0) {
          this.setState({ logoImage: `${apiUrl.apiUrl.url}/${selectedAsset[0].logo_image}` });
        } else {
          this.setState({ logoImage: null });
        }
        this.state.initialValues.assetDesc = selectedAsset[0].desc;
        this.setState({});
      }

      console.log(selectedAsset, "selectedAsset", selectedAsset.length)

    }


    console.groupEnd();
  };

  handleChangeSubAsset = (newValue, actionMeta) => {
    this.state.initialValues.subAssetName = newValue.label;
    this.state.initialValues.subAssetId = newValue.value;
    this.setState({});
    console.group("Value Changed");
    this.subAsset = newValue.value;

    console.groupEnd();
  };

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/asset/delete-tower?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",
        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };
  redirectToClose = () => {
    this.setState({ delete: false });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      assetImage: null,
      towerImage: null,
      tocImage: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        assetTypeId: "",
        region: "",
        assetId: "",
        subAssetId: "",
        towerName: "",
        assetName: "",
        subAssetName: "",
        assetType: "",
        latiTude: "",
        longiTude: "",
        pinCode: "",
        assetCompliance: [],
        ownershipType: "",
        isCoWorking: "",
        efficiencyOnUsableArea: "",
        totalSeatUsable: "",
        efficiencyOnBillableArea: "",
        totalSeatBillable: "",
        officeArea: "",
        structure: "",
        retailsArea: "",
        floorPlateRange: "",
        assetImage: "",
        towerImage: "",
        assetDesc: "",
        logoImage: null,
        tocImage: null,
        remCode:""
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",

      assetImage: null,
      towerImage: null,
      tocImage: null,
      logoImage: null,
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        assetTypeId: "",
        region: "",
        assetId: "",
        subAssetId: "",
        towerName: "",
        assetName: "",
        subAssetName: "",
        assetType: "",
        latiTude: "",
        longiTude: "",
        pinCode: "",
        assetCompliance: [],
        ownershipType: "",
        officeArea: "",
        structure: "",
        retailsArea: "",
        floorPlateRange: "",
        assetImage: "",
        towerImage: "",
        logoImage: null,
        tocImage: null,
        assetDesc: "",
        remCode:""
      },
    });
  };

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;

      this.complianceList(newValue.value, this.state.initialValues.assetId);
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
    console.log(this.groupId, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/asset-detail" />;
    }
    return (
      <div className="parentContainer">
        <div>{this.renderForm()}</div>
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li>
                <FontAwesomeIcon icon={faChevronRight} />
              </li>
              <li>
                <Link to="/masters/unit-directory">Unit Directory</Link>
              </li>
              <li>
                <FontAwesomeIcon icon={faChevronRight} />
              </li>
              <li>
                <Link to="#">Asset Detail</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            values.assetTypeId = this.state.initialValues.assetTypeId;
            values.assetId = this.state.initialValues.assetId;
            values.subAssetId = this.state.initialValues.subAssetId;
            values.assetImage = this.state.assetImage;
            values.towerImage = this.state.towerImage;

            values.logoImage = this.state.logoImage;
            values.tocImage = this.state.tocImage;

            values.assetDesc = this.state.initialValues.assetDesc;
            console.log(values, "===");
            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!",
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Group <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientGroup"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(
                                  e,
                                  "change_client_group"
                                );
                              }}
                              value={{
                                label: this.state.initialValues.groupName,
                                value: this.state.initialValues.groupId,
                              }}
                              options={this.state.LandlordGroups.map(
                                (item) => ({
                                  label: item.group_name,
                                  value: item.id,
                                })
                              )}
                            />
                            <ErrorMessage
                              name="clientGroup"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      )}

                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Name <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientName"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(
                                  e,
                                  "change_client_name"
                                );
                              }}
                              value={{
                                label: this.state.initialValues.clientName,
                                value: this.state.initialValues.clientId,
                              }}
                              options={this.state.clientList.map((item) => ({
                                label: item.client_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage
                              name="clientName"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      )}

                      <div className="newGridSectionInner">
                        <label>
                          Country <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="countryId"
                            onChange={(e) => {
                              this.changeCountry(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.countries.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.country_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="countryId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          State <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="stateId"
                            onChange={(e) => {
                              this.changeState(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.states.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.state_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="stateId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          District <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="districtId"
                            onChange={(e) => {
                              this.changeDistrict(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.districts.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.district_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="districtId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          City <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="cityId"
                            onChange={(e) => {
                              handleChange(e);
                              this.getCityId(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.cities.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.city_name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="cityId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Region <span className="astrik"></span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="region" />
                          <ErrorMessage
                            name="region"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          PinCode <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="pinCode" />
                          <ErrorMessage
                            name="pinCode"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Ownership Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="ownershipType"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="Leasehold" label="Leasehold" />
                            <option value="Freehold" label="Freehold" />
                          </Field>
                          <ErrorMessage
                            name="ownershipType"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Asset Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <CreatableSelect
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetTypeId"
                            onChange={(e) => {
                              this.handleChangeAssetType(e);
                            }}
                            value={{
                              label: this.state.initialValues.assetType,
                              value: this.state.initialValues.assetTypeId,
                            }}
                            options={this.state.assetTypes.map((item) => ({
                              label: item.asset_type,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="assetTypeId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Asset Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <CreatableSelect
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            onChange={(e) => {
                              this.handleChangeAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assets.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="assetId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Sub Asset Name</label>
                        <div className="position-relative">
                          <CreatableSelect
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="subAssetId"
                            onChange={(e) => {
                              this.handleChangeSubAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.subAssetName,
                              value: this.state.initialValues.subAssetId,
                            }}
                            options={this.state.subAssets.map((item) => ({
                              label: item.sub_asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="subAssetId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Tower <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="towerName" />
                          <ErrorMessage
                            name="towerName"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Latitude <span className="astrik"></span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="latiTude" />
                          <ErrorMessage
                            name="latiTude"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Longitude <span className="astrik"></span>
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="longiTude" />
                          <ErrorMessage
                            name="longiTude"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Developer Name</label>
                        <div className="position-relative">
                          <Field type="text" name="devName" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Developer Address</label>
                        <div className="position-relative">
                          <Field type="text" name="devAddress" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Developer Phone No</label>
                        <div className="position-relative">
                          <Field type="text" name="devPhoneNo" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Total Gross Leasable Area (GLA)</label>
                        <div className="position-relative">
                          <Field type="text" name="totalArea" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Total Carpet Area</label>
                        <div className="position-relative">
                          <Field type="text" name="totalCarpet" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Construction Status</label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="constructionStatus"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="ready" label="Ready" />
                            <option value="uc" label="U/C" />
                          </Field>
                          <ErrorMessage
                            name="constructionStatus"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Completion Date</label>
                        <div className="position-relative">
                          <Field type="date" name="completionDate" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Building Category</label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="buildingCategory"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="SEZ" label="SEZ" />
                            <option value="IT" label="IT" />
                            <option value="Non-IT" label="Non-IT" />
                          </Field>
                          <ErrorMessage
                            name="buildingCategory"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Coworking <span className="astrik"></span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="isCoWorking"
                            onChange={(e) => {
                              this.state.initialValues.isCoWorking =
                                e.target.value;
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="yes" label="Yes" />
                            <option value="no" label="No" />
                          </Field>
                          <ErrorMessage
                            name="isCoWorking"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>REM Code</label>
                        <div className="position-relative">
                          <Field type="text" name="remCode" />
                        </div>
                      </div>

                      {this.state.initialValues.isCoWorking == "yes" && (
                        <>
                          <div className="newGridSectionInner">
                            <label>Efficiency On Usable Area</label>
                            <div className="position-relative">
                              <Field
                                type="number"
                                name="efficiencyOnUsableArea"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Total no of Seats Usable</label>
                            <div className="position-relative">
                              <Field type="number" name="totalSeatUsable" />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Efficiency on Billable Area(Per Seat)</label>
                            <div className="position-relative">
                              <Field
                                type="number"
                                name="efficiencyOnBillableArea"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>Total no of Seats Billable</label>
                            <div className="position-relative">
                              <Field type="number" name="totalSeatBillable" />
                            </div>
                          </div>
                        </>
                      )}



                      {this.state.initialValues.assetCompliance.length > 0 && (
                        <>
                          <div className="newGridSectionInner">
                            <label className="gridColOneByThree">
                              Compliance Count: {this.state.compliance_count}
                            </label>
                          </div>
                          <div className="newGridSectionInner">
                            <label className="gridColOneByThree">
                              Compliance Complete Percent(%):
                              {this.state.compliance_percent}
                            </label>
                          </div>
                        </>
                      )}

                      {this.state.initialValues.assetCompliance.length > 0 && (
                        <div className="tableContainer leaseLandlord gridColOneByThree">
                          <table className="table tableSimple text-center borderTable">
                            <thead>
                              <tr>
                                <th>Compliance Name</th>
                                <th>Compliance Answer</th>
                              </tr>
                            </thead>
                            {this.state.initialValues.assetCompliance.map(
                              (obj, i) => (
                                <tr>
                                  <td>{obj.name}</td>
                                  {obj.compliance_datatype == "date" && (
                                    <td>
                                      <Field
                                        type="date"
                                        name={
                                          "assetCompliance[" + i + "].value"
                                        }
                                      />
                                    </td>
                                  )}
                                  {obj.compliance_datatype == "checkbox" && (
                                    <td>
                                      <Field
                                        type="checkbox"
                                        name={
                                          "assetCompliance[" + i + "].value"
                                        }
                                      />
                                    </td>
                                  )}
                                </tr>
                              )
                            )}
                          </table>
                        </div>
                      )}

                      <div className="gridColOneByThree">

                        <Accordion>
                          <Accordion.Item eventKey="0">
                            <Accordion.Header>Prospect Template</Accordion.Header>
                            <Accordion.Body>

                              <div className="newGridSectionForFormMain mb-4">
                                <div className="newGridSectionInner">
                                  <label>Structure</label>
                                  <div className="position-relative">
                                    <Field type="text" name="structure" />
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>Office Area</label>
                                  <div className="position-relative">
                                    <Field type="text" name="officeArea" />
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>Retail Area</label>
                                  <div className="position-relative">
                                    <Field type="text" name="retailsArea" />
                                  </div>
                                </div>

                                <div className="newGridSectionInner">
                                  <label>Floor Plate Range</label>
                                  <div className="position-relative">
                                    <Field type="text" name="floorPlateRange" />
                                  </div>
                                </div>
                              </div>

                              <div className="newGridSectionForFormMain customBorderClass align-items-start">
                                <div>
                                  <b>Asset Image </b>
                                  {this.state.assetImage ? (
                                    <div className="position-relative addImagePlaceholder addImagePlaceholderWithDelete">
                                      <img
                                        src={this.state.assetImage}
                                        className="img-fluid"
                                      />
                                      <spam className="deleteButton" onClick={(e) => {
                                        console.log("Calling asset")
                                        e.preventDefault();
                                        this.removeImage("asset")
                                      }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            fill="currentColor"
                                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
                                          />
                                        </svg>
                                      </spam>
                                    </div>
                                  ) : (
                                    <div className="position-relative addImagePlaceholder">
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                          this.onImageChange(e, "asset");
                                        }}
                                      />
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"
                                        />
                                      </svg>
                                    </div>
                                  )}

                                  {this.state.assetImage && (
                                    <>
                                      {this.state.showPopupAsset === true ? (
                                        <div className="fixedDiv">
                                          <Cropper
                                            src={this.state.assetImage}
                                            style={{ height: 400, width: "100%" }}
                                            // initialAspectRatio={1}
                                            aspectRatio={4 / 3}
                                            guides={false}
                                            viewMode={1}
                                            dragMode="move"
                                            ref={this.state.cropperRef}
                                          />
                                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-center">
                                            <button
                                              className="update_button"
                                              onClick={(e) => {
                                                console.log(e);
                                                this.setState({
                                                  showPopupAsset: false,
                                                });
                                                this.getCroppedImage(e, "asset");
                                              }}
                                            >
                                              Crop Image
                                            </button>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  )}

                                  <div>
                                    <b className="mb-3 d-block">Description </b>
                                    <CKEditor
                                      editor={ClassicEditor}
                                      data={this.state.initialValues.assetDesc}
                                      onReady={(editor) => {
                                        console.log(
                                          "Editor is ready to use!",
                                          editor
                                        );
                                      }}
                                      onChange={(event, editor) => {
                                        const data = editor.getData();
                                        this.state.initialValues.assetDesc = data;
                                        this.setState({});
                                      }}
                                      onBlur={(event, editor) => {
                                        console.log("Blur.", editor);
                                      }}
                                      onFocus={(event, editor) => {
                                        console.log("Focus.", editor);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div>
                                  <b>Tower Image </b>
                                  {this.state.towerImage ? (
                                    <div className="position-relative addImagePlaceholder addImagePlaceholderWithDelete">
                                      <img
                                        src={this.state.towerImage}
                                        className="img-fluid"
                                      />
                                      <spam className="deleteButton" onClick={() => {
                                        console.log("Calling tower")
                                        this.removeImage("tower")
                                      }} >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            fill="currentColor"
                                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
                                          />
                                        </svg>
                                      </spam>
                                    </div>
                                  ) : (
                                    <div className="position-relative addImagePlaceholder">
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                          this.onImageChange(e, "tower");
                                        }}
                                      />
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                  {this.state.towerImage && (
                                    <>
                                      {this.state.showPopupTower === true ? (
                                        <div className="fixedDiv">
                                          <Cropper
                                            src={this.state.towerImage}
                                            style={{ height: 400, width: "100%" }}
                                            initialAspectRatio={1}
                                            aspectRatio={4 / 3}
                                            guides={false}
                                            viewMode={1}
                                            dragMode="move"
                                            ref={this.state.cropperTowerRef}
                                          />
                                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-center">
                                            <button
                                              className="update_button"
                                              onClick={(e) => {
                                                console.log(e);
                                                this.setState({
                                                  showPopupTower: false,
                                                });
                                                this.getCroppedImage(e, "tower");
                                              }}
                                            >
                                              Crop Image
                                            </button>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  )}
                                </div>
                                <div>
                                  <b>TOC Image </b>
                                  {this.state.tocImage ? (
                                    <div className="position-relative addImagePlaceholder addImagePlaceholderWithDelete">
                                      <img
                                        src={this.state.tocImage}
                                        className="img-fluid"
                                      />
                                      <spam className="deleteButton" onClick={() => {
                                        console.log("Calling tower")
                                        this.removeImage("tocImage")
                                      }} >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            fill="currentColor"
                                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
                                          />
                                        </svg>
                                      </spam>
                                    </div>
                                  ) : (
                                    <div className="position-relative addImagePlaceholder">
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                          this.onImageChange(e, "tocImage");
                                        }}
                                      />
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                  {this.state.tocImage && (
                                    <>
                                      {this.state.showPopupToc === true ? (
                                        <div className="fixedDiv">
                                          <Cropper
                                            src={this.state.tocImage}
                                            style={{ height: 400, width: "100%" }}
                                            initialAspectRatio={1}
                                            aspectRatio={4 / 3}
                                            guides={false}
                                            viewMode={1}
                                            dragMode="move"
                                            ref={this.state.cropperTocRef}
                                          />
                                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-center">
                                            <button
                                              className="update_button"
                                              onClick={(e) => {
                                                console.log(e);
                                                this.setState({
                                                  showPopupToc: false,
                                                });
                                                this.getCroppedImage(e, "tocImage");
                                              }}
                                            >
                                              Crop Image
                                            </button>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  )}
                                </div>

                                <div>
                                  <b>Asset Logo </b>
                                  {this.state.logoImage ? (
                                    <div className="position-relative addImagePlaceholder addImagePlaceholderWithDelete">
                                      <img
                                        src={this.state.logoImage}
                                        className="img-fluid"
                                      />
                                      <spam className="deleteButton" onClick={() => {
                                        console.log("Calling tower")
                                        this.removeImage("logoImage")
                                      }} >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            fill="currentColor"
                                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
                                          />
                                        </svg>
                                      </spam>
                                    </div>
                                  ) : (
                                    <div className="position-relative addImagePlaceholder">
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                          this.onImageChange(e, "logoImage");
                                        }}
                                      />
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                  {this.state.logoImage && (
                                    <>
                                      {this.state.showPopupLogo === true ? (
                                        <div className="fixedDiv">
                                          <Cropper
                                            src={this.state.logoImage}
                                            style={{ height: 400, width: "100%" }}
                                            initialAspectRatio={NaN}
                                            //aspectRatio={4 / 3}
                                            guides={false}
                                            viewMode={1}
                                            dragMode="move"
                                            ref={this.state.cropperLogoRef}
                                          />
                                          <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-center">
                                            <button
                                              className="update_button"
                                              onClick={(e) => {
                                                console.log(e);
                                                this.setState({
                                                  showPopupLogo: false,
                                                });
                                                this.getCroppedImage(e, "logoImage");
                                              }}
                                            >
                                              Crop Image
                                            </button>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  )}
                                </div>

                              </div>

                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>


                      </div>


                    </div>

                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button
                          type="submit"
                          className="update_button"
                          disabled={isSubmitting}
                        >
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}
                        >
                          Delete
                        </button>
                        <button
                          type="reset"
                          className="reset_button"
                          onClick={this.redirectAfterEdit}
                        >
                          <Link to="/masters/asset-detail">Reset</Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button
                          type="submit"
                          className="add_button"
                          disabled={isSubmitting}
                        >
                          Add
                        </button>
                        <button
                          type="reset"
                          className="reset_button"
                          onClick={this.redirectAfterEdit}
                        >
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <TableComponent />
      </>
    );
  }
}

export default withRouter(AssetDetail);
